import * as React from 'react';
import { ActionButtonDefinition, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import { Res } from 'core/api';
import * as Images from 'pos/Images';
import { getDivisionParts } from './getDivisionParts';
import { Flex } from 'core/ui';
import { Message, Modal } from 'core/ui-next/modal';
import { SvgIcon } from 'core/ui-next';

type Props = { tableCompanions: Nullable<number>, pendingAmount: number } & Modal.Actions<DivisionMode>;

const Option = (props: { text: string, onClick: () => void, icon: SvgIcon }) => {

	return <div style={{ display: 'flex', alignItems: 'center' }} >
		<SvgIcon color='#D6AF28' width='40x' height='40px' src={props.icon} flexShrink={0} />
		<div className='m-l m-r-sm'>{props.text}</div>
		<div className='btn btn-default' onClick={props.onClick} style={{ minWidth: 64 }}><Images.Next /></div>
	</div>;
};

class GetDivisionScreen extends PosScreenClassComponent<Props, EmptyState> {

	createInitialState(_props: Props): Nullable<EmptyState> {
		return null;
	}

	onComponentDidMount(): void { }

	onComponentWillUnmount(): void { }

	protected getScreenId(): string {
		return 'GET_DIVISION_MODE';
	}

	protected getTitle(): string {
		return Res.Web.GET_SPLIT_MODE();
	}

	protected getImage(): string | SvgIcon {
		return Images.SplitTicket;
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	protected useKeypad() {
		return false;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			null
		];
	}

	protected getContent(): React.ReactNode {

		const onSplitPayments = async () => {

			if (this.props.pendingAmount < 0) {
				await Message.show(Res.Msg.MSG_CANNOT_SPLIT_PAYMENTS_FROM_NEGATIVE_TICKET());
				return;
			}

			const result = await getDivisionParts(this.props.tableCompanions);
			if (result.ok)
				this.close({ type: 'SplitPayment', parts: result.value });
		};

		const onSplitAuto = async () => {
			const result = await getDivisionParts(this.props.tableCompanions);
			if (result.ok)
				this.close({ type: 'SplitAuto', parts: result.value });
		};

		const onSplitManual = () => this.close({ type: 'SplitManual' });

		return <Flex.Vertical className='p-sm'>
			<Flex.Item className='text-18 m-t-sm'>
				{Res.Web.GET_SPLIT_METHOD_PAYMENTS_DIVISION_LBL()}
			</Flex.Item>
			<Flex.Item className='m-t'>
				<Option text={Res.Web.GET_SPLIT_METHOD_PAYMENTS_DIVISION_INFO_LBL()} icon={Images.SplitTicketPayments} onClick={onSplitPayments} />
			</Flex.Item>

			<Flex.Item><hr className='m-t-lg' /></Flex.Item>

			<Flex.Item className='text-18 m-t-sm'>
				{Res.Web.GET_SPLIT_MODE_MANUAL_DIVISION_LBL()}
			</Flex.Item>
			<Flex.Item className='m-t'>
				<Option text={Res.Web.GET_SPLIT_METHOD_AUTOMATIC_DIVISION_INFO_LBL()} icon={Images.SplitTicketAuto} onClick={onSplitAuto} />
			</Flex.Item>

			<Flex.Item className='m-t-lg'>
				<Option text={Res.Web.GET_SPLIT_MODE_MANUAL_DIVISION_INFO_LBL()} icon={Images.SplitTicketManual} onClick={onSplitManual} />
			</Flex.Item>

		</Flex.Vertical>;
	}
}

type DivisionMode = { type: 'SplitManual' } | { type: 'SplitAuto' | 'SplitPayment', parts: number }

export async function getDivisionMode(pendingAmount: number, tableCompanions: Nullable<number>): Promise<Result<DivisionMode>> {
	return await Modal.show(GetDivisionScreen, { tableCompanions, pendingAmount });
}